import React, { Component } from 'react';
import { Button, Col, Input, message, Row, Table } from 'antd';

import { queryProtectionSearch } from '@api/xxcrm/protect';
import { BackBtn } from '@comm/BackBtn';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  handleChange = e => {
    this.setState({
      userName: e.target.value.replace(/\s+/g, ''),
    });
  };

  search = () => {
    this.name = this.state.userName;
    queryProtectionSearch(this.name).then(res => {
      if (res.statusCode === 200) {
        if (res.data.length < 1) {
          const info = {};
          const data = [];
          info.name = this.name;
          info.isProtected = 0;
          data[0] = info;
          this.setState({
            data,
          });
          return;
        }
        this.setState({
          data: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  goBack = () => {
    this.props.router.go(-1);
  };

  columns = () => {
    return [
      {
        title: '客户名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '保护人',
        dataIndex: 'protectName',
        key: 'protectName',
      },
      {
        title: '状态',
        dataIndex: 'isProtected',
        key: 'isProtected',
        render: text => {
          return <span>{text === 1 ? '已保护' : '未保护'}</span>;
        },
      },
    ];
  };

  render() {
    const { data } = this.state;
    return (
      <div className="protect-sql">
        <Row type="flex" justify="space-between">
          <Col span={3}>
            <BackBtn />
          </Col>
          <Col span={21}>
            <Row
              type="flex"
              className="protect_search"
              justify="end"
              style={{ marginBottom: '16px' }}
            >
              <Col>
                <Input
                  placeholder="请输入客户名称"
                  style={{ width: '300px' }}
                  value={this.state.userName}
                  onChange={this.handleChange}
                  onPressEnter={this.search}
                />
                <Button type="primary" onClick={this.search} style={{ marginLeft: '10px' }}>
                  搜索
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Table rowKey="uuid" columns={this.columns()} dataSource={data} pagination={false} />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/xianxing/protect/ProtectSql.js